module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vgal4-4b811acb010be4a9fce8f5eda5523db2.jpg";